// COUNTDOWN SCRIPT
(function countdown(){
	let countDownDate = new Date("jun 06, 2025 11:59:59").getTime();

	// All of the containers and blocks
	const daysBlock = document.querySelectorAll("[data-countdown-days]");
	const hoursBlock = document.querySelectorAll("[data-countdown-hours]");
	const minutesBlock = document.querySelectorAll("[data-countdown-minutes]");
	const secondsBlock = document.querySelectorAll("[data-countdown-seconds]");
	const singleUnitBlock = document.querySelectorAll("[data-countdown-single-unit]"); 
	
	// Interval function to repeat the steps inside the function
	let x = setInterval(function () {
		let now = new Date().getTime();
		let distance = countDownDate - now; 
		let daysUnit = daysBlock !== 0 ? Math.floor(distance / (1000 * 60 * 60 * 24)) : 0;
		let hoursUnit = hoursBlock !== 0 ? Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) : 0;
		let minutesUnit = minutesBlock !== 0 ? Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)) : 0;
		let secondsUnit = secondsBlock !== 0 ? Math.floor((distance % (1000 * 60)) / 1000) : 0;

    	// Call functions for items (ONLY if they exist, if no output 0)
    	countdownItem(daysBlock, daysUnit);
    	countdownItem(hoursBlock, hoursUnit);
    	countdownItem(minutesBlock, minutesUnit);
    	countdownItem(secondsBlock, secondsUnit);
    	countdownItem(singleUnitBlock); 
		
		// conditional add unit/content to singleUnit or to unit block
		function countdownItem(item, unit) {
		    if(item === singleUnitBlock) {
		        item.forEach(item => {
					if(daysUnit > 1) {
						item.textContent = `${daysUnit} days to go`;
					} else if (daysUnit > 0) {
						item.textContent = `${daysUnit} day to go`;
					} else if (hoursUnit > 1) {
						item.textContent = `${hoursUnit} hours to go`;
					} else if (hoursUnit > 0) {
						item.textContent = `${hoursUnit} hour to go`;
					} else if (minutesUnit > 1) {
						item.textContent = `${minutesUnit} minutes to go`;
					} else if (minutesUnit > 0) {
						item.textContent = `${minutesUnit} minute to go`;
					} else if (secondsUnit > 1) {
						item.textContent = `${secondsUnit} seconds to go`
					} else if (secondsUnit > 0) {
						item.textContent = `${secondsUnit} second to go`
					}
		        })
		    } else {
		        item.forEach(item => {
		            item.textContent = unit;
		        });
		    }
		}
		
		// Stop the Interval and then call the resetItems function
		if(distance < 1) {
			clearInterval(x);
			resetItems();
		}

	}, 1000);
	
	// Could have put this in the condition above if(item === singleUnitBlock) ...But not it only runs this once when the interval is complete
	function resetItems(d = daysBlock, h = hoursBlock, m = minutesBlock, s = secondsBlock, sItem = singleUnitBlock) {
		d.forEach(e => e.textContent = 0);
		h.forEach(e => e.textContent = 0);
		m.forEach(e => e.textContent = 0);
		s.forEach(e => e.textContent = 0);
		sItem.forEach(e => {
			e.textContent = "0 seconds left";
		});
	}




	// Animate 1pp and hand
	const CTdepositCountdown = document.querySelectorAll('[data-1ppDepositCountdown]');

	CTdepositCountdown.forEach(countdown => {
		const CTdepositPointer = countdown.querySelector('.cCountdownPointerHand');
		const CTdepositLogo = countdown.querySelector('.cCountdown1ppLogo');

		if (!CTdepositPointer && !CTdepositLogo) return;

		const addAnimateClass = () => {
			addOrRemoveClass(CTdepositLogo, "cCTLogoAnimate")
			addOrRemoveClass(CTdepositPointer, "cCTHandAnimate")
		}
		const addOrRemoveClass = (item, IfClassIsActive) => {
			if (item.classList.contains(IfClassIsActive)) {
				item.classList.remove(IfClassIsActive)
			} else {
				item.classList.add(IfClassIsActive); 
			}
		}
		setInterval(addAnimateClass, 3000) 
	});

})();


